import api from "./api";

export async function getFeatures(usinaId) {
    const res = await api.get(`features/usina/${usinaId}`);
    return res.data;
}

export async function updateFeature(featureId, data) {
    const formData = new FormData();

    if (data.status !== undefined) {
        formData.append('status', JSON.stringify(data.status));
    }

    if (data.attachment) {
        formData.append('attachment', data.attachment);
    }

    const res = await api.patch(`features/${featureId}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });

    return res.data;
}
